import React, { useState } from 'react';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import FileUpload from '../../components/widgets/uploadFile';

function UploadFile() {
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });

  return (
    <Base>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>{alert.message}</Alert>}
      <FileUpload ></FileUpload>
    </Base>
  );
}

export default UploadFile;
